// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-add {
   background: darkgreen;
   color: white;
}

.input-deputy {
   margin-right: 15px;
}

.input-signatory {
   margin-right: 15px;
}

.hint {
   font-size: 12px;
   color: red;
}

.hint-none {
   display: none;
}

.hint-block {
   display: block;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

.mat-dialog-actions {
   margin-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/sender-reassign-dialog/sender-reassign-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,qBAAqB;GACrB,YAAY;AACf;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,UAAU;AACb;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,2BAA2B;AAC9B","sourcesContent":[".btn-add {\n   background: darkgreen;\n   color: white;\n}\n\n.input-deputy {\n   margin-right: 15px;\n}\n\n.input-signatory {\n   margin-right: 15px;\n}\n\n.hint {\n   font-size: 12px;\n   color: red;\n}\n\n.hint-none {\n   display: none;\n}\n\n.hint-block {\n   display: block;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n.mat-dialog-actions {\n   margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
